import { ORDERS_BASE_ROUTE, Routes } from '~/modules/routes';
import { extractURLComponents } from '~/modules/utilities/route_utils';
import { navigate, testIsNavigoLink } from '../stores/routerStore';
import { FF_CLIENT_SIDE_NAVIGATION } from '../utilities/featureFlags';

const ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;

/**
 * This method will return true if a link is an external link, which means:
 *
 *  a) The link is not '#'
 *  b) The link is an absolute path (starts with http:// or https://)
 *  c) The relative path of the link is not registered with the routerStore
 *
 * If the link is '#' or a relative path handled by the routerStore, this will return false.
 */
export function isExternalLink(link: string): boolean {
    if (link === '#' || link.includes(ORDERS_BASE_ROUTE)) {
        return false;
    }
    // TODO: Remove this entire block after we enable client side navigation by default (after GA)
    if (!FF_CLIENT_SIDE_NAVIGATION) {
        // Absolute paths are not handled correctly by Navigo, returning false here lets the browser handle them.
        if (ABSOLUTE_URL_REGEX.test(link)) {
            return true;
        }

        const urlComponents = extractURLComponents(link);
        const pathName = urlComponents?.pathName;
        const queryString = urlComponents?.queryString;
        // Navigations without a tab param need to be handled as external links
        if (!queryString) {
            return true;
        }
        const params = new URLSearchParams(queryString);
        if (!params.get('tab')) {
            return true;
        }
        // Do client side navigation on listing detail pages with tab params
        return Routes.LISTING !== pathName;
    }
    return !testIsNavigoLink(link);
}

export function isAnchorNavigation(url: string, event: MouseEvent | KeyboardEvent) {
    return isExternalLink(url) || isNewWindow(event);
}

// Navigate receives a url and href event. If navigate is correct prevents the href and uses router system to navigate to url
// @ts-expect-error * Automated Type Error Fix
export function navigateEvent(url, event) {
    if (!isAnchorNavigation(url, event)) {
        // Default is anchor navigation, so if isn't means will use router, thats why preventDefault and navigate otherwise nothing
        event.preventDefault();
        navigate(url);
    }
}

function isNewWindow(event: MouseEvent | KeyboardEvent): boolean {
    const isMacPlatform = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return (
        (event.target as HTMLAnchorElement).target === '_blank' ||
        (isMacPlatform && event.metaKey) ||
        (!isMacPlatform && event.ctrlKey)
    );
}
